"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
var Title_1 = require("./Title");
Object.defineProperty(exports, "Title", { enumerable: true, get: function () { return Title_1.Title; } });
